import React, { useState } from 'react';
// template components
import AssistiveText from '@nmx/template/dist/componentLibrary/components/AssistiveText';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Form from '@nmx/template/dist/componentLibrary/components/forms/Form';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// regex
import { truncateTrailingSlash } from '../../../../utils/globalRegex';
// styles
import {
  DivIconContainerStyled,
  FacebookLikeIconStyled,
  InputRadioStyled,
  LabelFafaPollStyled,
  TypographyLabelStyled,
  TypographyThankYouStyled,
} from './styles';

const extractPathFromBaseURI = (baseURI) => {
  const valHash = baseURI.indexOf('#');
  const valQuest = baseURI.indexOf('?');
  let valEnd;

  if (valHash > -1 && valQuest > -1) {
    valEnd = Math.min(valHash, valQuest);
  } else {
    valEnd = Math.max(valHash, valQuest);
  }

  let val = baseURI.substring(baseURI.indexOf('.com/') + 4, valEnd).replace(truncateTrailingSlash, '');
  if (val.length === 0) {
    val = 'home-page';
  }

  return val;
};

const getPageLoadPath = () => {
  if (typeof window !== 'undefined') {
    try {
      const baseURI = window.document.baseURI || '';
      const val = extractPathFromBaseURI(baseURI);
      return val.length === 0 ? 'home-page' : val;
    } catch (error) {
      // do nothing
    }
  }
  return '';
};

export default () => {
  const [fafaPollCompleted, setFafaPollCompleted] = useState(false);
  const pageLoadPath = getPageLoadPath();
  const formExperience = 'FAFA Poll';
  const getFormName = path => `Form: ${path} | ${formExperience}`;
  const formName = getFormName(pageLoadPath);

  const trackAdobeFill = (event) => {
    const { value, name } = event.target;

    // Interaction example from in page lead form
    window.adobeDataLayer.push({
      event: 'form-interact',
      form: {
        name: formName,
        experience: formExperience,
        'form-type': formExperience,
        'action-type': name,
        'action-keys': 'fafa-quiz-form-fill-nmx',
        'action-values': value,
      },
    });
  };

  const handlePollClick = (e) => {
    setFafaPollCompleted(true);
    trackAdobeFill(e);
  };

  return (
    <SectionContainer
      id='fafa-page-fafa-poll'
      className='js-show-on-submit'
      backgroundVariant='lightA'
      themeType='lightTheme'>
      {!fafaPollCompleted
        ? (
          <>
            <Row align='center'>
              <Col>
                <Typography
                  component='h2'
                  align='center'
                  disableBottomPadding>
                  Was this information useful&#63;
                </Typography>
              </Col>
            </Row>
            <Row align='center'>
              <Col medium={6}>
                <Form>
                  <fieldset>
                    <legend>
                      <AssistiveText>
                        Let us know if this information was useful.
                      </AssistiveText>
                    </legend>
                    <Row align='center'>
                      <LabelFafaPollStyled>
                        <DivIconContainerStyled>
                          <FacebookLikeIconStyled />
                        </DivIconContainerStyled>
                        <TypographyLabelStyled
                          component='span'
                          variant='h5'>
                          Yes
                        </TypographyLabelStyled>
                        <InputRadioStyled
                          id='fafa-quiz-poll-was-the-info-useful-yes'
                          value='yes'
                          name='fafaPoll'
                          type='radio'
                          onClick={handlePollClick} />
                      </LabelFafaPollStyled>
                      <LabelFafaPollStyled>
                        <DivIconContainerStyled inverted>
                          <FacebookLikeIconStyled />
                        </DivIconContainerStyled>
                        <TypographyLabelStyled
                          component='span'
                          variant='h5'>
                          No
                        </TypographyLabelStyled>
                        <InputRadioStyled
                          id='fafa-quiz-poll-was-the-info-useful-no'
                          value='no'
                          name='fafaPoll'
                          type='radio'
                          onClick={handlePollClick} />
                      </LabelFafaPollStyled>
                    </Row>
                  </fieldset>
                </Form>
              </Col>
            </Row>
          </>
        )
        : (
          <Row align='center'>
            <Col>
              <TypographyThankYouStyled
                variant='h1'
                align='center'>
                Thanks for your input&#33;
              </TypographyThankYouStyled>
            </Col>
          </Row>
        )}
    </SectionContainer>
  );
};
